import { useState } from "react";
import { UserRound, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { carregarEscritorio, useEscritorioInfo } from "@/lib/escritorioInfo";

// Lote 157 — "Responsável" no processo. Todos do escritório veem; só o administrador troca.
// (Sem escolha, o responsável é quem cadastrou/dono da conta onde o processo está.)
export default function ResponsavelProcesso({ processo, onTrocou }) {
  const info = useEscritorioInfo(true, true);
  const [busy, setBusy] = useState(false);
  if (!info?.existe || !processo?.responsavel_id) return null;
  const admin = info.meu_papel === "admin";
  const candidatos = (info.membros || []).filter((m) => m.papel !== "apoio");
  const atual = [...(info.membros || []), ...(info.ex_membros || [])].find((m) => m.user_id === processo.responsavel_id);
  const nome = processo.responsavel_nome || atual?.nome || "—";
  const trocar = async (id) => {
    if (!id || id === processo.responsavel_id) return;
    setBusy(true);
    try {
      const r = await http.put(`/escritorio/processos/${processo.processo_id}/responsavel`, { responsavel_id: id });
      toast.success(`Responsável: ${r.data.responsavel_nome || "atualizado"}`);
      carregarEscritorio(true);
      onTrocou && onTrocou({ responsavel_id: id, responsavel_nome: r.data.responsavel_nome });
    } catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível trocar o responsável"); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1.5 text-sm text-stone-600" data-testid="processo-responsavel">
      <UserRound className="w-4 h-4 text-stone-500" strokeWidth={1.75} />
      <span className="hidden sm:inline">Responsável:</span>
      {admin ? (
        <span className="relative inline-flex items-center">
        <select data-testid="processo-responsavel-select" disabled={busy} value={processo.responsavel_id} onChange={(e) => trocar(e.target.value)} aria-label="Responsável pelo processo"
          title="Clique para escolher outro responsável"
          className="h-8 appearance-none rounded-md border border-stone-300 bg-white pl-2 pr-7 text-xs sm:text-sm font-medium text-stone-900 max-w-[15rem] truncate cursor-pointer hover:border-stone-500 focus:outline-none focus:ring-2 focus:ring-gold-500">
          {!candidatos.some((m) => m.user_id === processo.responsavel_id) && <option value={processo.responsavel_id}>{nome} (saiu)</option>}
          {candidatos.map((m) => <option key={m.user_id} value={m.user_id}>{m.nome}{m.eu ? " (você)" : ""}{m.papel === "admin" ? " · administrador" : ""}</option>)}
        </select>
        <ChevronDown className="pointer-events-none absolute right-2 w-3.5 h-3.5 text-stone-600" aria-hidden="true" />
        </span>
      ) : <b className="font-semibold text-stone-900" data-testid="processo-responsavel-nome">{nome}</b>}
    </div>
  );
}
